import * as React from 'react';
import { Layout } from '../Layout';
import * as styles from './Documentation.css';

interface IDocumentationProps {
  title: React.ReactNode;
  documentation: React.ReactNode;
  showMore: React.ReactNode;
}

export function Documentation({ title, documentation, showMore }: IDocumentationProps) {
  return (
    <section id="documentation" className={styles['documentation']}>
      <Layout>
        <div className={styles['documentation__title']}>{title}</div>

        <ul className={styles['documentation__list']}>
          {React.Children.map(documentation, (item, index) => (
            <li key={index} className={styles['documentation__item']}>
              {item}
            </li>
          ))}
        </ul>

        <div className={styles['documentation__show']}>{showMore}</div>
      </Layout>
    </section>
  );
}
